import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Spoiler from '../../../../../../../../components/Spoiler'
import CostCapRadioButtons from './CostCapRadioButtons'

import { BUDGET_LIFETIME } from '../../../../../../../Multiplatform/CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const CostCapApproachQuestion = memo(({ setFieldValue, biddingType }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <div className={drawerFormClasses.subSection}>
      <Spoiler title="Advanced Settings" spoilerTitleClassName={classes.costCapSpoilerTitle}>
        <FieldLabelWrapper label={t('Cost cap')} labelFor={BUDGET_LIFETIME}>
          <p>{t('Select how the optimisation should work')}</p>

          <div className={drawerFormClasses.radioButtonsContainer}>
            <CostCapRadioButtons setFieldValue={setFieldValue} value={biddingType} />
          </div>
        </FieldLabelWrapper>
      </Spoiler>
    </div>
  )
})

CostCapApproachQuestion.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  biddingType: PropTypes.string
}

export default CostCapApproachQuestion
